import { render } from "./CategoryReport.vue?vue&type=template&id=f46f9c84"
import script from "./CategoryReport.vue?vue&type=script&lang=js"
export * from "./CategoryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__